import { z } from 'zod';
import { AUDIT_ACTIONS, type AuditAction } from '../enums.js';
import { paginationQuerySchema, uuidSchema } from './common.js';

export const AUDIT_SORT_FIELDS = ['createdAt'] as const;

export const listAuditLogsQuerySchema = paginationQuerySchema.extend({
  sortBy: z.enum(AUDIT_SORT_FIELDS).default('createdAt'),
  action: z.enum(AUDIT_ACTIONS).optional(),
  entityType: z.string().trim().min(1).max(64).optional(),
  entityId: uuidSchema.optional(),
  actorId: uuidSchema.optional(),
  /** Inclusive lower bound on `createdAt`. */
  from: z.iso.datetime().optional(),
  /** Exclusive upper bound on `createdAt`. */
  to: z.iso.datetime().optional(),
});
export type ListAuditLogsQuery = z.infer<typeof listAuditLogsQuerySchema>;

export interface AuditLogEntry {
  id: string;
  action: AuditAction;
  entityType: string;
  entityId: string | null;
  entityLabel: string | null;
  actorId: string | null;
  actorEmail: string | null;
  actorName: string | null;
  changes: Record<string, { from: unknown; to: unknown }> | null;
  changedFields: string[];
  ipAddress: string | null;
  requestId: string | null;
  createdAt: string;
}
